<template>
  <el-carousel :interval="4000" type="card" height="200px">
    <el-carousel-item v-for="item in 6" :key="item">
      <h3 class="medium">{{ item }}</h3>
    </el-carousel-item>
  </el-carousel>
</template>
<script>
  import {WOW} from 'wowjs'
  import {mapGetters} from 'vuex'

  export default {
    name: 'LinkUs',
    components: {},
    props: {},
    data () {
      return {
        labelPosition: 'right',
        formLabelAlign: {
          name: '',
          region: '',
          type: ''
        }
      };
    },
    methods: {},
    mounted () {
      const wow = new WOW({
        boxClass: 'wow',
        animateClass: 'animated',
        offset: 0,
        mobile: true,
        live: false
      })
      wow.init()
    },
    computed: {
      ...mapGetters(['lang']),
      getComponentName () {
        return 'LinkUs'
      }
    }

  }
</script>
<style>
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n+1) {
  background-color: #d3dce6;
}
</style>



// WEBPACK FOOTER //
// src/components/common/contactus/MessageUs.vue